<template>
  <jet-dialog-modal :show="isDistributorModel" @close="closeDistributorPopup">
    <template #title>
      <div class="flex justify-between items-center text-xl font-bold">
        Create New Distributor
      </div>
    </template>

    <template #content>
      <div class="max-w-7xl mx-auto space-y-8">
        <!-- FORM HEADER -->
        <div class="bg-white p-6 shadow rounded-xl space-y-6">
          <!-- Select Box -->
          <div>
            <label class="block text-sm font-medium mb-1">Distributor Name</label>
            <input type="text" required v-model="disForm.name" class="w-full border px-3 py-2 rounded-lg" placeholder="Enter Distributor Name" />
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end items-center">
        <button @click="createDistributor" :disabled="disForm.name === ''"
          class="inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-red-500 text-white text-base disabled:opacity-25">Create</button>
      </div>
    </template>
  </jet-dialog-modal>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal';
import axios from 'axios';
import { create } from 'lodash';
export default {
  name: "AttachDistributor",
  props: [],
  components: {
    JetDialogModal,
  },
  data() {
    return {
      isDistributorModel: true,
      items: [],
      selectedDistributorId: '',
      item_type: 'exist',
      selectedItem: null,
      disForm: this.$inertia.form({
        name: ''
      })
    };
  },
  methods: {

    createDistributor() {
      // Logic to get distributor data
      if (!this.disForm.name) {
        return;
      }
      axios.post(`/create-distributor`, this.disForm)
      .then(response => {
        console.log('Distributor created successfully:', response.data);
        this.$emit('create-new-distributor', response.data);
      })
      .catch(error => {
        console.error('Error fetching distributor items:', error);
      });
    },
    sendToProductPage() {
      let itemData = this.selectedItem;
      if (!itemData) {
        this.$toast.error('Please select a distributor item to attach');
        return;
      }
      itemData.distributor = { 'id': this.selectedDistributorId, 'name': this.all_distributors.find(d => d.id === this.selectedDistributorId).name };
      this.$emit('attach-distributor-item', itemData);
      this.closeDistributorPopup();
    },
    closeDistributorPopup() {
      this.items = [];
      this.selectedDistributorId = '';
      this.item_type = 'exist';
      this.selectedItem = null;
      this.$emit('close');
    },
    saveToDistributorItem() {
      // require validation
      if (!this.disForm.item_number || !this.disForm.pack || !this.disForm.size || !this.disForm.brand || !this.disForm.mpc_code || !this.disForm.case_qty || !this.disForm.case_total || !this.disForm.case_avg || !this.disForm.case_weight || !this.disForm.cost_per_lb || !this.disForm.total_cases || !this.disForm.description) {
        // alert('Please fill all required fields');
        this.$toast.error('Please fill all required fields');
        return;
      }


      this.disForm.distributor_id = this.selectedDistributorId;

      axios.post('/save-distributor-items', this.disForm).then((response) => {
        // console.log(responce);
        let itemData = response.data;
        // let itemData = this.disForm;
        itemData.distributor = { 'id': this.selectedDistributorId, 'name': this.all_distributors.find(d => d.id === this.selectedDistributorId).name };
        this.$emit('attach-distributor-item', itemData);
        this.closeDistributorPopup();
      });

      // this.disForm.post('/save-distributor-items').then((responce) => {
      //   console.log(responce);
      //   // let itemData = responce.data;
      //   // // let itemData = this.disForm;
      //   // itemData.distributor = {'id' : this.selectedDistributorId, 'name' : this.all_distributors.find(d => d.id === this.selectedDistributorId).name};
      //   // this.$emit('attach-distributor-item', itemData);
      //   // this.closeDistributorPopup();
      // });
    }
  }
}
</script>
